import Navigation from '../../components/layout/Navigation';
import Footer from '../../components/layout/Footer';
import Hero from '../../components/ui/Hero';
import CultureSection from './components/CultureSection';
import BenefitsSection from './components/BenefitsSection';
import OpeningsSection from './components/OpeningsSection';
import ContactSection from './components/ContactSection';

export default function CareersPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      <Hero 
        title={<>Shape the Future <span className="gradient-text">with Hash Adz</span></>}
        description="Build Tomorrow's Digital Landscape, Today. We're always seeking passionate, innovative minds to join our growing team in Kochi, Kerala."
        bgImage="/assets/modern-collaborative-office.png"
        primaryBtn={{ text: "View Open Positions", link: "/careers#openings" }}
        secondaryBtn={{ text: "Explore Our Culture", link: "/careers#culture" }}
      />
      <div className="relative z-10 bg-black">
        <div id="culture"><CultureSection /></div>
        <BenefitsSection />
        <div id="openings"><OpeningsSection /></div>
        <ContactSection />
      </div>
      <Footer />
    </div>
  );
}